import React from 'react'
import type { ExplorerPane as TExplorerPane } from 'types/explorer'
import { CUSTOM_CHANNEL } from '@disco/constants/GroupTypes'
import ExplorerTrialAlert, {
  useShowExplorerTrialAlert,
} from 'components/common/explorer-trial-alert'
import ExplorerPane from '../pane'

const PaneList = ({
  panes,
  colWidth,
  colCount,
  user,
  library,
  style,
  isPhone,
}: {
  panes: TExplorerPane[]
  colWidth: number
  colCount: number
  user: any
  library: any
  style: Record<string, any>
  isPhone: boolean
}): React.ReactNode => {
  const showExplorerTrialAlert = useShowExplorerTrialAlert()
  return (
    <>
      <div className="Explorer_Inner" style={style}>
        {panes.map((pane, index) => {
          const hasCreateFolderBtn = pane.groupType === CUSTOM_CHANNEL
          let isSmall
          let isWideSortingColumn

          if (hasCreateFolderBtn) {
            // "Create Folder" takes ~30px. 320+30=350
            isSmall = colWidth < 320
            isWideSortingColumn = colWidth >= 350
          } else {
            isSmall = colWidth < 290
            isWideSortingColumn = colWidth >= 320
          }

          let explorerPaneHeight = '100%'
          const explorerPane = (
            <ExplorerPane
              key={index}
              library={library}
              user={user}
              prevPane={index >= 1 ? panes[index - 1] : null}
              pane={pane}
              colCount={colCount}
              colWidth={colWidth}
              isSmall={isSmall}
              isSortingWide={isWideSortingColumn}
              style={{
                height: explorerPaneHeight,
              }}
            />
          )

          if (!isPhone) {
            return (
              <div className="Explorer__Column" key={index}>
                {explorerPane}
              </div>
            )
          }

          return explorerPane
        })}
        <div className="Explorer_RightSpacer hidden-phone" />
      </div>

      {showExplorerTrialAlert && (
        <div className="Explorer_TrialAlert">
          <ExplorerTrialAlert />
        </div>
      )}
    </>
  )
}

export default PaneList
